import useAdmin from '@/globalVariable'
const admin = useAdmin()
const hasPermission = (roleName: string): boolean => {
  // Get the user permissions from localStorage and parse it as an array of strings
  const userPermissionsString = localStorage.getItem(admin.LS_PERMISSION_KEY_NAME)
  if (!userPermissionsString) return false
  
  try {
    let userPermissions: string[] = []
    // Handle both JSON array format and comma-separated string format
    if (userPermissionsString.startsWith('[') && userPermissionsString.endsWith(']')) {
      userPermissions = JSON.parse(userPermissionsString)
    } else {
      // Handle comma-separated string format
      userPermissions = userPermissionsString
        .split(',')
        .map((permission) => permission.trim())
        .filter(Boolean)
    }
    return userPermissions.includes(roleName)
  } catch (e) {
    console.error('Error parsing user permissions:', e)
    return false
  }
}

export default hasPermission
